import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useState } from 'react';

export default function LabeledSelectField({ label, value, onChange, options, size, error, helperText }) {
    const [isFocused, setIsFocused] = useState(false);
    const [hasFocused, setHasFocused] = useState(false);

    if (!size) {
        size = 12;
    }
    return (
        <Grid size={size}>
            <FormControl fullWidth error={!isFocused && hasFocused && error}>
                <InputLabel id={`${label}-select-label`}>{label}</InputLabel>
                <Select
                    labelId={`${label}-select-label`}
                    id={`${label}-select-label`}
                    value={value}
                    label={label}
                    onChange={onChange}
                    sx={{ width: '100%' }}
                    error={!isFocused && hasFocused && error}
                    onFocus={() => {
                        setIsFocused(true);
                        setHasFocused(true);
                    }}
                    onBlur={() => setIsFocused(false)}
                >
                    {options.map(item => {
                        return (
                            <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                        );
                    })}
                </Select>
                {helperText && <Typography variant="caption" color={!isFocused && hasFocused ? 'error' : null}>{helperText}</Typography>}
            </FormControl>
        </Grid>
    );
}